export default () => ({
  container: {
    padding: 24,
  },
});
